module.exports = __webpack_public_path__ + "static/media/scanHistory.cc81d3e4.svg";